import { toast } from '@tribeplatform/react-ui-kit/Toast';
/**
 * Shows a red notification like error message
 * @param message Second line (description) of the toast message
 */
export const composerError = (intl) => (message) => {
    toast({
        title: intl.$t({
            id: 'Generics.Error',
            defaultMessage: 'Error',
        }),
        description: message,
        status: 'error',
    });
};
/**
 * File upload error handler
 * @param error Error object with fileName property
 */
export const fileUploadError = (intl) => error => {
    toast({
        title: intl.$t({
            id: 'Composer.Errors.UnableToUpload',
            defaultMessage: 'Unable to upload {file_name}',
        }, {
            file_name: (error === null || error === void 0 ? void 0 : error.fileName) || '',
        }),
        description: error === null || error === void 0 ? void 0 : error.message,
        status: 'error',
    });
};
//# sourceMappingURL=errors.js.map